import {useFetchOneEntry} from '../useFetchOneEntry'
import builderConfig from 'hec/builder/model-map'

const useFetchParentLevel = ({moduleContentId, apiKey, shouldQuery, fields}) =>
    useFetchOneEntry({
        queryKey: ['Builder-Fetch-Learning-Center-Parent-Level', moduleContentId],
        options: {
            model: builderConfig.learningCenterLevel,
            apiKey: apiKey,
            enrich: false,
            query: {
                data: {
                    modules: {
                        $elemMatch: {
                            'module.id': {$eq: moduleContentId}
                        }
                    }
                }
            },
            fields: fields || 'id,data'
        },
        enabled: !!moduleContentId && shouldQuery
    })

export default useFetchParentLevel
